var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarPainel)?_c('div',{staticClass:"mt-2"},[_vm._m(0),_c('b-list-group',[_c('PainelPagamentosMensaisMenu')],1)],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"heading-1"},[_c('span',[_vm._v("Painéis")])])
}]

export { render, staticRenderFns }